import './profile-image.scss';

import PropTypes from 'prop-types';
import React, { useContext } from 'react';

import { UserContext } from '../../context';

const ProfileImage = ({ location }) => {
  const { user } = useContext(UserContext);
  const { merchantName = 'BQ' } = user;

  const merchantNames = merchantName.split(' ');

  let initials = '';

  if (merchantNames.length >= 2) {
    initials = merchantNames[0][0] + merchantNames[1][0];
  } else {
    initials = merchantName.substr(0, 2);
  }

  return (
    <div className={`profile__image profile__image--${location}`}>
      <span className="initials">{initials}</span>
    </div>
  );
};

ProfileImage.defaultProps = {
  location: 'sidebar'
};

ProfileImage.propTypes = {
  location: PropTypes.oneOf(['sidebar', 'navbar', 'settings', 'settings-edit'])
};
export { ProfileImage };
